// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "vue-marquis/css/" + ({"924":"owners.properties.documents","3270":"owners.bookings.inquiries"}[chunkId] || chunkId) + "." + {"924":"aaa7220d","3270":"468cd430","4503":"72e35b2e","6237":"74b8e565","9901":"81022ebb"}[chunkId] + ".css";
};